import { ENROLL_PERSON_REQUEST_SET, ENROLL_PERSON_REQUEST_REMOVE } from '../../actions/enroll-person-request/types';

const emptyState = {};

export default function enrollPersonRequest(state = emptyState, { type, data }) {
  switch (type) {
    case ENROLL_PERSON_REQUEST_SET:
      return {
        ...emptyState,
        ...data,
      };
    case ENROLL_PERSON_REQUEST_REMOVE:
      return emptyState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/enroll-person-request/index.js